import request from '@/utils/zsm-requets'
const notice = '/zsm/api/notice/' // 公告
/** 创建订单
 @param teacher_mobile 讲师微信
 @param teacher_weixin_show_flag 讲师微信是否公开
 @param teacher_nick 讲师店铺昵称
 @param teacher_nick_hide_flag 讲师是否匿名
 @param notice_title 标题
 @param notice_open_flag 推广任务是否开启
 @param notice_begin_date 推广任务开始时间
 @param notice_end_date 推广任务结束时间
 @param notice_in_time_flag 推广任务是否在时间范围内
 @param notice_platform_dict 推广平台
 @param notice_type 推广形式
 @param notice_reward 推广任务奖励
 @param notice_desc 推广任务描述
 @param notice_dist_fans_flag  推广达人是否要求粉丝数
 @param notice_dist_fans_min 最小粉丝数
 @param notice_good_id 推广商品
 @param notice_good_title 推广商品名称
 @param notice_good_price 推广商品价格
 @param audit_progress 最大粉丝数
 */
export function saveNotice(info) {
  return request({
    url: notice + 'save',
    method: 'post',
    params: info
  })
}

/**
 * 获取通告详情
 * @param id 通告id
 * @returns {*}
 */
export function getNotice(id) {
  return request({
    url: notice + 'get',
    method: 'post',
    params: { id }
  })
}

/**
 * 删除通告
 * @param id 通告id
 * @returns {*}
 */
export function deleteNotice(id) {
  return request({
    url: notice + 'delete',
    method: 'post',
    params: { id }
  })
}
/**
 * 修改通告开关状态
 * @param openFlag  	1.开启 2.关闭
 * @param id 通告id
 * @returns {*}
 */
export function modifyNoticeOpenFlag(params) {
  return request({
    url: notice + 'modifyNoticeOpenFlag',
    method: 'post',
    params
  })
}

/** 获取通告列表数据
 @param teacher_mobile 讲师微信
 @param teacher_weixin_show_flag 讲师微信是否公开
 @param teacher_nick 讲师店铺昵称
 @param teacher_nick_hide_flag 讲师是否匿名
 @param notice_title 标题
 @param notice_open_flag 推广任务是否开启
 @param notice_begin_date 推广任务开始时间
 @param notice_end_date 推广任务结束时间
 @param notice_in_time_flag 推广任务是否在时间范围内
 @param notice_platform_dict 推广平台
 @param notice_type 推广形式
 @param notice_reward 推广任务奖励
 @param notice_desc 推广任务描述
 @param notice_dist_fans_flag  推广达人是否要求粉丝数
 @param notice_dist_fans_min 最小粉丝数
 @param notice_good_id 推广商品
 @param notice_good_title 推广商品名称
 @param notice_good_price 推广商品价格
 @param audit_progress 最大粉丝数
 */
export function listDataNotice(params) {
  return request({
    url: notice + 'listData',
    method: 'post',
    params
  })
}



/**
 * 通告申请列表
 *	 @param id 通告id
 * 	 @param applyProgress 申请进度
 *	 @param auditProgress 审核进度
 *	 @param distFansNum 达人粉丝数
 *	 @param distId 达人id
 *	 @param distMobile 达人手机号
 *	 @param distNick 达人昵称
 * 	 @param noticeId 通告id
 *	 @param noticeTitle 通告标题
 *	 @returns {*}
 */
export function noticeApplyListData(params) {
  return request({
    url: notice + 'noticeApplyListData',
    method: 'post',
    params
  })
}



/**
 *  审核通告任务
 *	 @param id 通告id
 * 	 @param applyProgress 申请进度
 *	 @param auditProgress 审核进度
 *	 @param distFansNum 达人粉丝数
 *	 @param distId 达人id
 *	 @param distMobile 达人手机号
 *	 @param distNick 达人昵称
 * 	 @param noticeId 通告id
 *	 @param noticeTitle 通告标题
 *	 @returns {*}
 */
export function noticeApplyAudit(params) {
  return request({
    url: notice + 'noticeApplyAudit',
    method: 'post',
    params
  })
}

/**
 *  删除用户申请的通告内容
 *	 @param id 通告申请id
 *	 @returns {*}
 */
export function delNoticeApply(params) {
  return request({
    url: notice + 'delNoticeApply',
    method: 'post',
    params
  })
}
